export const groundworksSumAnalysis = [
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "GROUNDWORKS PHASE 1 (PLOTS 30-37, 167-210)",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "PRELIMINARIES",
    "": "",
    Amount: "£5,475.00",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "SITE CLEARANCE, CUT & FILL AND REMOVAL OF SURPLUS ARISINGS",
    "": "",
    Amount: "£283,187.67",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "FOUNDATIONS & FLOORS ",
    "": "",
    Amount: "£1,370,881.64",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "PLOT DRAINAGE - FOUL",
    "": "",
    Amount: "£128,060.36",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "PLOT DRAINAGE - STORM",
    "": "",
    Amount: "£118,272.54",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "SHARED AND PRIVATE DRIVES",
    "": "",
    Amount: "£322,240.49",
  },
  {
    Description: "EO 60mm BINDER COURSE TO PERMEABLE SHARED DRIVES",
    "": "£27,962.00",
    Amount: "£27,962.00",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "PLOT PATHS",
    "": "",
    Amount: "£87,392.02",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "GARDENS AND WALLS",
    "": "",
    Amount: "£166,323.42",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "POS AREA (PHASE 1 ONLY)",
    "": "",
    Amount: "£9,100.52",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "SCAFFOLD PLATFORM",
    "": "",
    Amount: "£44,301.02",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "PLOT SERVICES AND CONNECTIONS",
    "": "",
    Amount: "£65,839.14",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "DAYWORKS",
    "": "",
    Amount: "Rates Provided",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "DISCOUNT",
    "": "",
    Amount: "-£131,451.79",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "TENDER TOTAL",
    "": "",
    Amount: "£2,497,584",
  },
];
